import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderInputs, commonAddressInputs, commonPersonInputs } from "./utils";
import { useSubmit } from "module/common/components/forms";
import { putProperties } from "module/main/store/appEndpoints/api";
import Dropdown from "module/common/components/Dropdown";
var Properties = function (_a) {
    var formRef = _a.formRef, formSubmitCallBack = _a.formSubmitCallBack;
    var handleSubmit = useSubmit(function (request) {
        var buildAddressLookup = function (street, city, state, zipcode) {
            return [street, city, state, zipcode].some(Boolean)
                ? {
                    street: street || null,
                    city: city || null,
                    state: state || null,
                    zipcode: zipcode || null,
                }
                : null;
        };
        var buildPersonNameLookup = function (first_name, middle_name, last_name) {
            return [first_name, middle_name, last_name].some(Boolean)
                ? {
                    first_name: first_name || null,
                    middle_name: middle_name || null,
                    last_name: last_name || null,
                }
                : null;
        };
        var buildOwnerEntityLookup = function (mailingAddress, businessName, personName) {
            return [mailingAddress, businessName, personName].some(Boolean)
                ? {
                    mailing_address_lookup: mailingAddress,
                    business_name_lookup: businessName,
                    person_name_lookup: personName,
                }
                : null;
        };
        var mailingAddress = buildAddressLookup(request.mailing_street, request.mailing_city, request.mailing_state, request.mailing_zipcode);
        var personName = buildPersonNameLookup(request.first_name, request.middle_name, request.last_name);
        var ownerEntity = buildOwnerEntityLookup(mailingAddress, request.business_name || null, personName);
        var curatedPayload = {
            property_lookups: [
                {
                    property_address_lookup: {
                        street: request.property_street,
                        city: request.property_city,
                        state: request.property_state,
                        zipcode: request.property_zipcode,
                    },
                    owner_entity_lookup: ownerEntity,
                },
            ],
        };
        formSubmitCallBack(putProperties, curatedPayload);
    });
    var propertyAddressForm1 = renderInputs(commonAddressInputs.slice(0, 2), "property");
    var propertyAddressForm2 = renderInputs(commonAddressInputs.slice(2), "property");
    var mailingAddressForm1 = renderInputs(commonAddressInputs.slice(0, 2), "mailing");
    var mailingAddressForm2 = renderInputs(commonAddressInputs.slice(2), "mailing");
    var personNameForm = renderInputs(commonPersonInputs);
    var businessInputs = [
        {
            id: "business_name",
            name: "business_name",
            placeholder: "Enter Business Name",
            label: "Business Name",
            type: "text",
        },
    ];
    var businessForm = renderInputs(businessInputs);
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col", id: "endpoints-form", ref: formRef, children: [_jsx("h5", { className: "font-bold mb-2", children: "Property address:" }), _jsxs("div", { className: "pl-2", children: [_jsx("div", { className: "form-row", children: propertyAddressForm1 }), _jsx("div", { className: "form-row", children: propertyAddressForm2 })] }), _jsx(Dropdown, { text: _jsx("h5", { className: "font-bold mb-2 inline", children: "Owner entity:" }), color: "unset", children: _jsxs("div", { className: "pl-2", children: [_jsx("div", { className: "form-row", children: personNameForm }), businessForm, _jsx("h6", { className: "font-bold mb-2", children: "Owner Mailing address:" }), _jsx("div", { className: "form-row", children: mailingAddressForm1 }), _jsx("div", { className: "form-row", children: mailingAddressForm2 })] }) })] }));
};
export default Properties;
